import React, { useEffect, useState } from 'react';
import { CornerDownRightIcon, LockIcon, UsersIcon } from 'lucide-react';
import { formatUsd } from '../../utils/format';
import { Button } from '../sf/Button';
import { StoredReference } from '../sf/StoredReference';
import { Modal } from '../sf/Modal';
import { NewBadge } from '../sf/NewBadge';
interface LockPeriodModalProps {
  open: boolean;
  payTotal: number;
  adjustedTotal: number;
  payeeCount: number;
  lineCount: number;
  lateChangeCount: number;
  onClose: () => void;
  onConfirm: () => void;
}
export function LockPeriodModal({
  open,
  payTotal,
  adjustedTotal,
  payeeCount,
  lineCount,
  lateChangeCount,
  onClose,
  onConfirm
}: LockPeriodModalProps) {
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => {
    if (!open) setConfirmed(false);
  }, [open]);
  const consequences = [{
    icon: UsersIcon,
    text: `Locks every employee’s October 2026 period — all ${payeeCount} payees at once.`
  }, {
    icon: LockIcon,
    text: `All ${lineCount} commission lines become read-only. Recalculate is disabled for October 2026.`
  }, {
    icon: CornerDownRightIcon,
    text: `${lateChangeCount} late changes post as Adjustment lines to November 2026 — never as edits to October.`
  }];
  return <Modal open={open} onClose={onClose} title="Lock October 2026?" description="Only an admin can unlock, and a reason is required." footer={<>
          <Button onClick={onClose} data-id="element-617" data-mp="1n1iawqzi6n6a">Cancel</Button>
          <Button variant="brand" disabled={!confirmed} icon={<LockIcon data-id="element-619" data-mp="1i3guyexdj3z1" />} onClick={onConfirm} data-id="element-618" data-mp="1i48lhbc46big">
            Lock Period
          </Button>
        </>} data-id="element-616" data-mp="1d66ve6g9tbxh">
      <div className="space-y-4" data-id="element-620" data-mp="1w1nhx00sbjjx">
        <p className="flex flex-wrap items-center gap-2 text-xs text-sf-weak" data-id="element-621" data-mp="1s2fsp2glpf79">
          <NewBadge data-id="element-622" data-mp="1s0bqqq29iq9m" />
          Period locking is a proposed rebuild feature — main has no period lock today.
        </p>
        <div className="rounded bg-sf-bg px-4 py-3" data-id="element-623" data-mp="3ttswfo6u1h1q">
          <p className="text-[11px] text-sf-weak" data-id="element-624" data-mp="3tvc974ta59yr">Adjusted · pays</p>
          <p className="text-2xl font-bold tabular-nums" data-id="element-625" data-mp="1wtycpwgwpsq0">{formatUsd(adjustedTotal)}</p>
          <StoredReference value={payTotal} data-id="element-626" data-mp="21r6mp9rwiqg6" />
        </div>
        <ul className="space-y-2.5" data-id="element-627" data-mp="21tt4e28iamc4">
          {consequences.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-2.5 text-[13px]" data-id="element-628" data-mp="26t5o4e42zdah">
              <Icon className="mt-0.5 h-4 w-4 shrink-0 text-sf-weak" aria-hidden="true" data-id="element-629" data-mp="2bqxgtacjv3fq" />
              {text}
            </li>)}
        </ul>
        <label className="flex cursor-pointer items-start gap-2 border-t border-sf-border pt-4 text-[13px]" data-id="element-630" data-mp="2kqu8zly5ekfj">
          <input type="checkbox" autoFocus checked={confirmed} onChange={event => setConfirmed(event.target.checked)} className="mt-0.5 h-4 w-4 accent-sf-blue" data-id="element-631" data-mp="2phu4qnvj6wgg" />
          I reviewed the pre-close checklist, parity and payee totals.
        </label>
      </div>
    </Modal>;
}